import { useTranslation } from 'react-i18next'
import { Paper, UnstyledButton } from '@mantine/core'
import { stage, stages } from '../lib/taskFilters'
import { BoardDot, TaskAssignees, TaskDeadline, TaskLabels } from './TaskPresentation'
import { allCardFields } from '../lib/cardFields'
import { IconCheck, IconChevronRight } from '@tabler/icons-react'
import { useLocalStorage } from '@mantine/hooks'

export default function PlannerList({ tasks, data, user, openDetails, fields = allCardFields, hideCompleted, selectedIds = null }) {
  const { t } = useTranslation()
  const [collapsed, setCollapsed] = useLocalStorage({ key: 'heliview-collapsed-list-groups', defaultValue: [] })
  const toggle = key => setCollapsed(collapsed.includes(key) ? collapsed.filter(item => item !== key) : [...collapsed, key])
  return <Paper className="task-list-wrap grouped-task-list">
    {Object.entries(stages).filter(([key]) => !(hideCompleted && key === 'completed')).map(([key, title]) => {
      const group = tasks.filter(task => stage(task) === key)
      return <section key={key} aria-label={t(title)}>
        <UnstyledButton className="list-group-heading" onClick={() => toggle(key)} aria-expanded={!collapsed.includes(key)}><IconChevronRight size={14} className={`list-group-chevron ${collapsed.includes(key) ? '' : 'is-open'}`}/><span className={`status-dot status-${key}`}/><strong>{t(title)}</strong><span>{group.length}</span></UnstyledButton>
        {!collapsed.includes(key) && group.map(task => <UnstyledButton key={task.id} className={`compact-task-row ${selectedIds?.includes(task.id) ? 'is-selected' : ''}`} onClick={() => openDetails(task)} aria-pressed={selectedIds ? selectedIds.includes(task.id) : undefined}>
          {selectedIds && <span className={`select-check ${selectedIds.includes(task.id) ? 'is-on' : ''}`} aria-hidden><IconCheck size={12}/></span>}
          <span className={`status-dot status-${key}`}/>
          <span className={`list-task-title ${key === 'completed' ? 'is-completed' : ''}`}>{task.title}</span>
          {fields.board && <span className="list-source"><BoardDot id={task.board.id}/><span>{task.board.title}</span></span>}
          {fields.labels && <TaskLabels task={task}/>}
          {fields.deadline && <TaskDeadline task={task}/>}
          {fields.assignees && <TaskAssignees task={task} people={data?.people} user={user}/>}
        </UnstyledButton>)}
      </section>
    })}
    {!tasks.length && <div className="list-empty">{data ? t("Geen taken met deze filters") : t("Nog geen brondata geladen")}</div>}
  </Paper>
}
